import type { PropsWithChildren } from "react";

import { ErrorBoundaryWithLogging } from "app/pages/sales-intelligence/common-components/ErrorBoundaryWithLogging";

import { ChatMessageError } from "../ChatMessage/ChatMessageError";

export const MessageErrorBoundary = ({ children }: PropsWithChildren) => {
    return <ErrorBoundaryWithLogging fallback={<ChatMessageError />}>{children}</ErrorBoundaryWithLogging>;
};
